import { render, staticRenderFns } from "./AddProductReviewBtn.vue?vue&type=template&id=c2778f04&scoped=true&"
import script from "./AddProductReviewBtn.vue?vue&type=script&lang=js&"
export * from "./AddProductReviewBtn.vue?vue&type=script&lang=js&"
import style0 from "./AddProductReviewBtn.vue?vue&type=style&index=0&id=c2778f04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2778f04",
  null
  
)

export default component.exports